import React from "react";
import { Image } from "react-native";

import Btc from "@/assets/btc.svg";
import Dai from "@/assets/dai.svg";
import Eth from "@/assets/eth.svg";
import Eur from "@/assets/euro.svg";
import Matic from "@/assets/matic.svg";
import Usdt from "@/assets/tether.svg";
import Tron from "@/assets/trx.svg";
import Usdc from "@/assets/usdc.svg";

export function checkIcon(type: string, size?: number) {
  const typeParts = type.split("_");
  const usdCase = typeParts.some((part) => part === "USD");
  const eurCase = typeParts.some((part) => part === "EUR");
  const ethCase = typeParts.some((part) => part === "ETH");
  const btcCase = typeParts.some((part) => part === "BTC");
  const usdcCase = typeParts.some((part) => part === "USDC");
  const usdtCase = typeParts.some((part) => part === "USDT");
  const tronCase = typeParts.some((part) => part === "TRX");
  const maticCase = typeParts.some((part) => part === "MATIC");
  const daiCase = typeParts.some((part) => part === "DAI");
  const polCase = typeParts.some((part) => part === "POL");
  const defaultCase =
    typeParts.some((part) => part === "FIAT") &&
    !typeParts.some((part) => part === "USD");

  const iconSize = size ? size : 24;

  if (usdCase)
    return (
      <Image
        source={require("@/assets/usrounded.png")}
        style={{ height: iconSize, width: iconSize }}
        resizeMode="contain"
      />
    );
  if (eurCase) return <Eur width={iconSize} height={iconSize} />;
  else if (ethCase) return <Eth width={iconSize} height={iconSize} />;
  else if (btcCase) return <Btc width={iconSize} height={iconSize} />;
  else if (usdtCase) return <Usdt width={iconSize} height={iconSize} />;
  else if (usdcCase) return <Usdc width={iconSize} height={iconSize} />;
  else if (tronCase) return <Tron width={iconSize} height={iconSize} />;
  else if (maticCase) return <Matic width={iconSize} height={iconSize} />;
  else if (polCase) return <Matic width={iconSize} height={iconSize} />;
  else if (daiCase) return <Dai width={iconSize} height={iconSize} />;
  else if (defaultCase)
    return (
      <Image
        source={require("@/assets/usrounded.png")}
        style={{ height: iconSize, width: iconSize }}
        resizeMode="contain"
      />
    );
  else return null;
}

export function checkAsset(type: string) {
  const typeParts = type.split("_");
  const usdCase = typeParts.some((part) => part === "USD");
  const eurCase = typeParts.some((part) => part === "EUR");
  const ethCase = typeParts.some((part) => part === "ETH");
  const btcCase = typeParts.some((part) => part === "BTC");
  const usdcCase = typeParts.some((part) => part === "USDC");
  const usdtCase = typeParts.some((part) => part === "USDT");
  const tronCase = typeParts.some((part) => part === "TRX");
  const maticCase = typeParts.some((part) => part === "MATIC");
  const daiCase = typeParts.some((part) => part === "DAI");
  const defaultCase =
    typeParts.some((part) => part === "FIAT") &&
    !typeParts.some((part) => part === "USD");

  if (usdCase) return "USD";
  else if (eurCase) return "EUR";
  else if (ethCase) return "ETH";
  else if (btcCase) return "BTC";
  else if (usdtCase) return "USDT";
  else if (usdcCase) return "USDC";
  else if (tronCase) return "TRX";
  else if (maticCase) return "MATIC";
  else if (daiCase) return "DAI";
  else if (defaultCase) return "USD";
  else return "-";
}

export function checkAssetPrecision(type: string): number {
  const asset = checkAsset(type);

  switch (asset) {
    case "BTC":
      return 5;
    case "ETH":
      return 4;
    case "USDC":
      return 3;
    case "USDT":
      return 3;
    case "MATIC":
      return 3;
    case "TRX":
      return 3;
    default:
      return 2;
  }
}

export function checkAssetBlockchain(type: string) {
  const typeParts = type.split("_");
  const solanaCase = typeParts.some((part) => part === "SOLANA");
  const ethereumCase = typeParts.some((part) => part === "ETHEREUM");
  const bitcoinCase = typeParts.some((part) => part === "BITCOIN");
  const tronCase = typeParts.some((part) => part === "TRON");
  const polygonCase = typeParts.some((part) => part === "POLYGON");

  if (solanaCase) return "SOLANA";
  else if (ethereumCase) return "ETHEREUM";
  else if (bitcoinCase) return "BITCOIN";
  else if (tronCase) return "TRON";
  else if (polygonCase) return "POLYGON";
  else return "-";
}

export const blockchainAssets = {
  BITCOIN: ["BTC"],
  ETHEREUM: ["ETH", "USDC", "USDT", "DAI", "MATIC"],
  POLYGON: ["MATIC", "USDC"],
  SOLANA: ["SOL", "USDC"],
  TRON: ["TRX", "USDT"],
};
